import {getRecipeList} from "@/api/Recipe"

export default {
  addRecipe({ commit }, recipe) {
    return new Promise((resolve, reject) => {
      commit('ADD_RECIPE', recipe)
      resolve()
        .catch((error) => { reject(error) })
    })
  },
  copyRecipe({ commit }, recipe) {
    return new Promise((resolve, reject) => {
      commit('COPY_RECIPE', recipe)
      resolve()
        .catch((error) => { reject(error) })
    })
  },
  fetchDataListItemsRecipe({ commit },payload) {
    return new Promise((resolve, reject) => {
      getRecipeList(payload)
      .then((response) => {
        if(response.status === 200){
        commit('SET_RECIPE', response.data);
        resolve(response);
        }else{
          reject(new Error("Listeleme İşlemi Başarısız ! " + response.status));
        }
      })
      .catch(error => {
        reject(new Error("Sunucu Bağlantısı Başarısız !"));
      })
    })
  },
  updateRecipe({ commit }, recipe) {
    return new Promise((resolve, reject) => {
      commit('UPDATE_RECIPE', recipe)
          resolve()
        .catch((error) => { reject(error) })
    })
  },
  removeRecipe({ commit }, recipeId) {
    return new Promise((resolve, reject) => {
      commit('REMOVE_RECIPE', recipeId)
          resolve();
    })
  }
};
